import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PendingChangesService {
  readonly canRedirect = signal(false);

  allowNextRedirect(): void {
    this.canRedirect.set(true);
  }
}
